/**
 * MarketInsightDetailPanel — 报告详情内嵌面板展示层（3列布局专用）
 *
 * 纯展示容器，占满父列高度，左侧有分隔线。
 * 不负责布局本身（宽度、列数由父组件的 flex/grid 决定）。
 *
 * 使用方式：
 * ```tsx
 * // 父组件用 flex-row 三列布局，此组件占最右列
 * <div className="flex h-full">
 *   <div className="flex-1">消息流</div>
 *   {detailOpen && (
 *     <MarketInsightDetailPanel
 *       useStore={storeRef.current}
 *       onClose={() => setDetailOpen(false)}
 *       className="w-[380px]"
 *     />
 *   )}
 * </div>
 * ```
 */

import cn from 'classnames';
import { MarketInsightDetail } from '../detail';
import type { createMarketInsightStore } from '../card/store';

export type MarketInsightDetailPanelProps = {
  /** 与卡片共享的 store 实例 */
  useStore: ReturnType<typeof createMarketInsightStore>;
  /** 关闭面板回调 */
  onClose: () => void;
  /** 外部附加 className（通常用于控制宽度） */
  className?: string;
};

/**
 * 报告详情内嵌面板
 * - h-full 占满父列高度
 * - 左侧 border-l 分隔线
 * - 内部滚动由 MarketInsightDetail 自身处理
 */
export function MarketInsightDetailPanel({ useStore, onClose, className }: MarketInsightDetailPanelProps) {
  return (
    <div
      className={cn('h-full flex flex-col overflow-hidden border-l border-[#E5E5E5] bg-[#FCFDFD]', className)}
      style={{ borderLeftWidth: '0.365px' }}
    >
      <MarketInsightDetail useStore={useStore} onClose={onClose} />
    </div>
  );
}
